import React from "react";

import Consts from "../../../helpers/consts";
import { generateRelevanceTooltip } from "../../../helpers/velocityIndexTooltip";
import CreatorResultsCounter from "../CreatorResultsCounter";
import { ReactComponent as ArrowIcon } from "src/images/arrow-down.svg";

export const COLUMN_KEY_TO_HEADER = {
  name: {
    id: "front_username",
  },
  interests: {
    id: "front_interests",
    defaultMessage: "Interests",
  },
  relevance: {
    id: "front_relevance",
    defaultMessage: "relevance",
    tooltip: generateRelevanceTooltip(Consts.socialProvider.instagram),
  },
  recentPosts: {
    id: "front_recent_posts",
    defaultMessage: "Recent posts",
  },

  avgEr: {
    id: "front_avg_er",
    defaultMessage: "avg. ER",
    tooltip: {
      id: "front_avg_er_tooltip",
      defaultMessage: "avg. ER tooltip",
    },
  },
};

export function getColumnHeader(key, label) {
  return (
    COLUMN_KEY_TO_HEADER[key] ?? {
      id: `front_${key}`,
      defaultMessage: label,
    }
  );
}

export const STICKY_COLUMN_WIDTHS = {
  selectPage: 44,
  preview: 104,
};

const STICKY_LEFT_GUTTER = 48;

export const STICKY_OFFSETS = {
  selectPage: STICKY_LEFT_GUTTER,
  preview: STICKY_LEFT_GUTTER + STICKY_COLUMN_WIDTHS.selectPage,
  name:
    STICKY_LEFT_GUTTER +
    STICKY_COLUMN_WIDTHS.selectPage +
    STICKY_COLUMN_WIDTHS.preview,
};

export function getCreatorResultsColumns({
  list,
  checked,
  onSelectAllClick,
  endOfList,
  columns = [],
  sortBy,
  sortOrder = "desc",
  onSortColumn,
  showSortArrows = true,
}) {
  const SORT_KEY_BY_COLUMN_KEY = {
    avgEngagements: "engagements",
  };

  const getSortKeyForColumn = (columnKey) =>
    SORT_KEY_BY_COLUMN_KEY[columnKey] ?? columnKey;

  const handleSortArrowClick = (columnKey) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    const sortKey = getSortKeyForColumn(columnKey);

    if (sortKey === sortBy) {
      onSortColumn?.(sortKey, sortOrder === "asc" ? "desc" : "asc");
    }
  };

  const dataColumns = columns.flatMap(({ key, label }) => {
    const header = getColumnHeader(key, label);
    const sortKey = getSortKeyForColumn(key);
    const isActive = sortKey === sortBy;

    if (key === "name") {
      return [
        {
          ...header,
          beforeTextComponent: <CreatorResultsCounter endOfList={endOfList} />,
          toLeft: true,
          sticky: true,
          stickyLeft: STICKY_OFFSETS.name,
          stickyLast: true,
        },
        {
          id: "name-spacer",
          empty: true,
          className: "cdt-table__name-spacer",
        },
      ];
    }

    const sortArrow =
      showSortArrows && isActive ? (
        <button
          type="button"
          className="cs-table__sort-arrow-btn"
          onClick={handleSortArrowClick(key)}
          data-qa={`sort-arrow-${key}`}
        >
          <span
            className={`cs-table__sort-arrow${
              sortOrder === "asc" ? " cs-table__sort-arrow--asc" : ""
            } cs-table__sort-arrow--active`}
          >
            <ArrowIcon />
          </span>
        </button>
      ) : null;

    return [
      {
        ...header,
        toLeft: true,
        minWidth: 105,
        className: "cs-table__header--sortable",
        beforeTextComponent: sortArrow,
      },
    ];
  });

  return [
    list.length > 0
      ? {
          id: "front_select_page",
          defaultMessage: "Select page",
          empty: true,
          width: STICKY_COLUMN_WIDTHS.selectPage,
          sticky: true,
          stickyLeft: STICKY_OFFSETS.selectPage,
          selectAll: {
            checked,
            onChange: onSelectAllClick,
            disabled: false,
          },
        }
      : {
          id: "front_select_page",
          empty: true,
          width: STICKY_COLUMN_WIDTHS.selectPage,
          sticky: true,
          stickyLeft: STICKY_OFFSETS.selectPage,
        },
    {
      id: "preview",
      empty: true,
      className: "cdt-table__image cdt-table__image--small",
      sticky: true,
      stickyLeft: STICKY_OFFSETS.preview,
    },
    ...dataColumns,
    { id: "spacer", empty: true, className: "cdt-table__spacer" },
  ];
}
